import { Injectable } from '@angular/core';
import { SAUCER_LOG_ACTION } from '@core/configs';
import { SaucerLogService } from './saucer-log.service';

@Injectable({ providedIn: 'root' })
export class TitleSettingDialogLogService {
  constructor(private saucerLogService: SaucerLogService) {}

  view(): void {
    this.writeAction(SAUCER_LOG_ACTION.TITLE_LINK_SETTING_DIALOG.VIEW);
  }

  close(): void {
    this.writeAction(SAUCER_LOG_ACTION.TITLE_LINK_SETTING_DIALOG.CLOSE_DIALOG);
  }

  showTagInfo(): void {
    this.writeAction(SAUCER_LOG_ACTION.TITLE_LINK_SETTING_DIALOG.SHOW_DIALOG);
  }

  titleAddedorDeleted(tag: any,action:string): void {
    this.writeAction(SAUCER_LOG_ACTION.TITLE_LINK_SETTING_DIALOG.VIEW, {
      operation: action,
      ...this.toTitleTagLog(tag)
    });
  }

  defaultRestored(oldTags: any[], newTags: any[]): void {
    try {
      const isNothingChanged = JSON.stringify(oldTags) === JSON.stringify(newTags);

      if(isNothingChanged)
      {
        const content = { operation: 'restoreDefaultSettings', result: 'Nothing change' };
        this.writeAction(SAUCER_LOG_ACTION.TITLE_LINK_SETTING_DIALOG.UPDATE, content);
        return;
      }

      const action = oldTags.length === 0 && newTags.length > 0
        ? SAUCER_LOG_ACTION.TITLE_LINK_SETTING_DIALOG.CREATE
        : oldTags.length > 0 && newTags.length === 0 ? SAUCER_LOG_ACTION.TITLE_LINK_SETTING_DIALOG.DELETE
        : SAUCER_LOG_ACTION.TITLE_LINK_SETTING_DIALOG.UPDATE;

      const content = {
        old: { operation: 'restoreDefaultSettings', settings: oldTags },
        new: { operation: 'restoreDefaultSettings', settings: newTags }
      };
      this.writeAction(action, content);
    } catch {
      // SaucerLog failures must not interrupt the calling screen.
    }
  }

  getTitleTagSnapshot(tags: any[]): any[] {
    try {
      return (tags ?? []).map(tag=>({
        ...this.toTitleTagLog(tag),
        answerTags:tag?.answerTags ?? []
      }))
    } catch {
      return [];
    }
  }

  private toTitleTagLog(tag: any): any {
    return {
      title: tag?.ttlName,
      titleTag: tag?.kbnTtlTag,
      itemTag: tag?.iTag,
      itemName: tag?.iTagName
    };
  }

  private writeAction(action: any, content?: any): void {
    try {
      const params = content === undefined ? {} : { content: JSON.stringify(content) };
      void this.saucerLogService.action(params, { action }).catch(() => undefined);
    } catch {
      // SaucerLog failures must not interrupt the calling screen.
    }
  }
}
